import BranchFundingSourceBaseController from '../common/branch_funding_source.base.controller'

class BranchFundingSourceallController extends BranchFundingSourceBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, BranchFundingSourceService, $translate, $stateParams, $scope, $location) {

    super(Auth, $state, User, BranchFundingSourceService, Modal, $translate, $stateParams, $location)

    this.id = 'branch-funding-source.all'
    this._status = 'all'
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.loading = true
    this.branchFundingSourceData = []
    this.hasAcl = {}
    this.searchText = '';
    this.$location = $location;
    this.branch = User.getUser().branchId;
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(branchFundingSource) {
    this.$state.go('branch-funding-source.edit', ({
      id: branchFundingSource.id
    }))
  }

  delete(branchFundingSource) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${branchFundingSource.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(branchFundingSource.id, this.branch)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  generateSearchObj() {
    const obj = {
      queryJSON: {
        rules: [{
          field: 'branchId',
          condition: '=',
          data: this.branch
        },
        {
          group: {
            rules: [{
              field: 'id',
              condition: 'like',
              data: '%' + this.searchText + '%'
            },
            {
              field: 'sourceName',
              condition: 'like',
              data: '%' + this.searchText + '%'
            }
            ],
            operator: 'OR'
          }
        }
        ],
        operator: 'AND'
      }
    }
    return obj.queryJSON.rules.length ? obj : null;
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  // Load All BranchFundingSource
  loadData() {
    const searchObj = this.generateSearchObj();

    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total;
        this.branchFundingSourceData = data.results;
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        this.error = err.message;
      })
  }

}

export default BranchFundingSourceallController;



// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/all/branch_funding_source.all.controller.js